var React = require('react');

function Empty (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30 15c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15Z","fill":"#EA650D"}));
}

Empty.defaultProps = {"width":"30","height":"30","fill":"none"};

module.exports = Empty;

Empty.default = Empty;
